import React, { FC, useCallback } from 'react';
import { Selector, useSelector } from 'react-redux';
import { CopiesList } from './CopiesList';
import { AppState } from '../../store/appState';
import { SpocState } from '../../store/authentication/state';
import { useCopiesList } from './useCopiesList';
import { ListProduct, UsageCondition } from '../../../models/Product';
import { mapLoanFormat } from '../../../models/LoanFormat';

type Props = {
    readonly product: any;
    readonly disabled?: boolean;
    readonly usageCondition?: UsageCondition;
    readonly onRemoveCopy?: (copyId: number) => void;
    readonly removeCopyHint?: string;
    readonly setShowDropDown: (showDropDown: boolean) => void;
};

const CopiesListContainer: FC<Props> = props => {
    const { product, disabled = false, usageCondition, setShowDropDown, onRemoveCopy, ...listProps } = props;
    const { copies, loading, removeCopyById } = useCopiesList({ product, usageCondition });

    const spoc = useSelector(selectSpoc);

    const handleRemoveCopyById = useCallback(
        (copyId: number) => {
            if (onRemoveCopy) {
                onRemoveCopy(copyId);
            } else {
                removeCopyById(copyId).then();
            }
            setShowDropDown(false);
        },
        [onRemoveCopy, setShowDropDown, removeCopyById]
    );

    const netValue = usageCondition
        ? (product as unknown as ListProduct).lineItems?.find(lineItem => {
              const { lendingModel, usageLimit, termLimit } = lineItem.price ?? {};
              return (
                  usageCondition?.lendingModel === lendingModel &&
                  usageCondition?.usageLimit === usageLimit &&
                  usageCondition?.termLimit === termLimit
              );
          })?.price?.netValue ?? product.price?.netValue
        : product.price?.netValue;

    return (
        <CopiesList
            {...listProps}
            loanFormat={mapLoanFormat(product.loanFormat)!}
            netValue={netValue}
            currency={product.price?.currency}
            taxName={spoc.taxName}
            copies={copies}
            loading={loading}
            disabled={disabled}
            onRemove={handleRemoveCopyById}
        />
    );
};

export default CopiesListContainer;

const selectSpoc: Selector<AppState, SpocState> = state => {
    return state.authentication.spoc;
};
